import React, { Component } from 'react';
import './navBar.scss';
import * as img from '../../lib/images'
class NavBar extends Component {
    state = {
        tabs: [
            { name: 'Our Story', page: "/", refName:"ourStoryRef"},
            { name: 'Our Product', page: "/", refName:"ourProductRef" },
            { name: 'Technologies', page: "/", refName:"ourTechRef" },
            { name: 'Contact Us', page: "/", refName:"contactRef" },
        ],
        menuDrawer : false
    }
    menuDrawer = () => {
        this.setState({
            menuDrawer: !this.state.menuDrawer
        })
    }
    componentDidMount = () => {
      
    }
    render() {
        // console.log("ourStoryRef",this.props.setOurStoryRef);
        if(this.props.isMobile) {
            return(
                <div className="navBar w-100  align-items-center ">
                   <div className="w-100 d-flex align-items-center justify-content-between" style={{position:"relative"}}>
                     <img className="navIcon" src={img.MAIN_LOGO}/>
                    <img onClick={this.menuDrawer} className="menuIcon" src={img.MENU_ICON} />
                   </div>
                   {
                        this.state.menuDrawer ?  <div className="menuDrawer pl-4" style={{background:"#fff",zIndex:"20",position:"absolute"}}> 
                        {this.state.tabs.map(res=>{
                            return(
                            <div  className="p-2 w-100">
                                <p className="m-0"  style={{fontSize:"0.8rem"}}>{res.name}</p>
                            </div>
                            )
                        })}
                        
                   </div> : null
                   }
                   
                 

                    {/* <div className="col-6 p-0 d-flex">
                        {this.state.tabs.map(item=>{
                            return (<div className="col-3 d-flex justify-content-end p-0">
                        <p className="tabText m-0">{item.name}</p>
                            </div>)
                        })}
                    </div> */}
                </div>
            )
        } else {
            return (
                <div className="navBar d-flex align-items-center">
                    <div className="col-6 p-0">
                        <img className="navIcon" src={img.MAIN_LOGO}/>
                    </div>
                    <div className="col-6 p-0 d-flex">
                        {this.state.tabs.map(item=>{
                            return (<div className="col-3 d-flex justify-content-end p-0">
                        <p onClick={()=>this.props.scrollToMyRef(item.refName)} className="tabText m-0">{item.name}</p>
                            </div>)
                        })}
                    </div>
                </div>
            );
        }
        
    }
}

export default NavBar;